
import React from 'react'
import PropTypes from 'prop-types'
import TempResponsiveScreen from '@components/TempResponsiveScreen'
import RecordingPlayer from './RecordingPlayer'
import Download from '@root/components/Icon/Download'
import { Menu, MenuItem } from '@material-ui/core'
import TreeIcon from '@root/components/Icon/Tree'


class ZoomStreamGroup extends TempResponsiveScreen {
  static propTypes = {
    zoomRecordingStore: PropTypes.object,
    recordings: PropTypes.object,
    eplStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    const { zoomRecordingStore } = this.props

    this.state = {
      selectedType: zoomRecordingStore.recordingTypes.VIDEO,
      menuElement: null
    }
  }

  switchSelectedType(selectedType) {
    if (selectedType) this.setState({ ...this.state, selectedType })
  }

  handleMenuOpen = (event) => {
    this.setState({ menuElement: event.currentTarget })
  }

  handleMenuClose = () => {
    this.setState({ menuElement: null })
  }

  render() {
    const { recordings, eplStore } = this.props
    const { recordingTypes } = this.props.zoomRecordingStore
    const { selectedType } = this.state

    const video = recordings.find(recording => recording.fileExtension === 'MP4')
    const audio = recordings.find(recording => recording.fileExtension === 'M4A')

    if (!video && !audio) return (<div>No recordings were found for this expert.</div>)

    //On initial load, if there is #video or #audio at end of link, use it to select type
    if (window.location.hash) {
      const hash = window.location.hash

      if (hash.includes('audio')) this.switchSelectedType(recordingTypes.AUDIO)
      else this.switchSelectedType(recordingTypes.video)

      //remove from URL, hash should only have effect on initial load
      // eslint-disable-next-line no-restricted-globals
      history.replaceState({}, document.title, window.location.href.split('#')[0])
    }

    if (!video && selectedType === recordingTypes.VIDEO) this.switchSelectedType(recordingTypes.AUDIO)

    const transcript = recordings.find(recording => recording.fileExtension === 'VTT')
    const recording = selectedType === recordingTypes.VIDEO ? video : audio

    const recordingDownloadUrl = eplStore.generateRecordingDownloadUrl(recording)
    const transcriptDownloadUrl = transcript && eplStore.generateRecordingDownloadUrl(transcript)

    const playerSize = selectedType === recordingTypes.VIDEO ? { width: '100%', height: '50%' } : { width: '320px', height: '50px' }

    const isMenuOpen = Boolean(this.state.menuElement)

    return (
      <div className='recording-group'>
        {/* video/audio switcher and download */}
        <div className='recording-group-header'>
          <div className='recording-group-types-switcher'>
            {video && (
              <div className={`recording-group-type${selectedType === recordingTypes.VIDEO ? ' active' : ''}`} onClick={() => this.switchSelectedType(recordingTypes.VIDEO)}>
                Video
              </div>
            )}
            {audio && (
              <div className={`recording-group-type${selectedType === recordingTypes.AUDIO ? ' active' : ''}`} onClick={() => this.switchSelectedType(recordingTypes.AUDIO)}>
                Audio
              </div>
            )}
          </div>
          <div className='recording-group-downloads'>
            {recordingDownloadUrl && (
              <span
                className='download-link'
                onClick={() => { window.open(recordingDownloadUrl) }}>Download recording</span>
            )}

            {transcriptDownloadUrl && (
              <span
                className='download-link'
                onClick={() => { window.open(transcriptDownloadUrl) }}>Download transcript</span>
            )}
          </div>
          <div className='recording-group-downloads-mobile'>
            {recordingDownloadUrl || transcriptDownloadUrl ? (
              <>
                <Download onClick={this.handleMenuOpen} />
                <Menu
                  anchorEl={this.state.menuElement}
                  open={isMenuOpen}
                  onClose={this.handleMenuClose}>
                  {recordingDownloadUrl && (
                    <MenuItem onClick={() => { window.open(recordingDownloadUrl) }}>Download recording</MenuItem>
                  )}
                  {transcriptDownloadUrl && (
                    <MenuItem onClick={() => { window.open(transcriptDownloadUrl) }}>Download transcript</MenuItem>
                  )}
                </Menu>
              </>
            ) : null}
          </div>
        </div>

        {recording && (
          <RecordingPlayer
            type={selectedType}
            streamUrl={recording.streamUrl}
            transcriptUrl={transcript && transcript.streamUrl}
            playerSize={playerSize}
          />
        )}

        <TreeIcon />
      </div>
    )
  }
}

export default ZoomStreamGroup

